import K8ReportingStatusBox from './component'
export default K8ReportingStatusBox
